// extracted by css-extract-rspack-plugin
export default {"cls1":"HeroThumbnailStack-cls1_V3T","cls2":"HeroThumbnailStack-cls2_r4c HeroThumbnailStack-cls1_V3T"};